<template>
  <v-container
    fluid>
    <v-row
    >
      <v-col v-if="guidanceEntries.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          No guidance entries have been entered.
        </v-alert>
      </v-col>
      <v-col
        v-if="dbasename === 'BalmoralSDA'"
        cols="12">
        <v-card class="mb-3">
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Awards</th>
                    <th class="text-left">Times</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(count, award) in awardCounts"
                    :key="award">
                    <td>{{ award }}</td>
                    <td>{{ count }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        v-for="entry in guidanceEntries"
        :key="entry.id">
        <v-card class="mb-3">
          <v-card-text>
            <span
              v-for="(entryData, entryDetail) in entry"
              :key="entryDetail">
              <span class="font-weight-bold">{{ entryDetail }}</span>: {{ entryData }}
              <br>
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      guidanceEntries: [],
      awardCounts: {},
      dbasename: ''
    }
  },
  methods: {
    callIncident () {
      this.calculateAwardCounts()
      return this.guidanceEntries.map(entry => ({
        Award: entry.Incident,
        Times: this.awardCounts[entry.Incident] || 0
      }))
    },
    calculateAwardCounts () {
      this.awardCounts = {}
      const currentYear = new Date().getFullYear()
      this.guidanceEntries.forEach(entry => {
        const regex = /\b\d{4}\b/
        const match = entry.Date.match(regex)
        if (match) {
          const entryYear = parseInt(match[0], 10)
          if (entryYear === currentYear) {
            if (this.awardCounts.hasOwnProperty(entry.Incident)) {
              this.awardCounts[entry.Incident]++
            } else {
              this.awardCounts[entry.Incident] = 1
            }
          }
        } else {
          console.log('No year found in entry:', entry.Date)
        }
      })
    }
    // calculateAwardCounts () {
    //   this.awardCounts = {}
    //   console.log(this.guidanceEntries)
    //   this.guidanceEntries.forEach(entry => {
    //     if (this.awardCounts.hasOwnProperty(entry.Incident)) {
    //       this.awardCounts[entry.Incident]++
    //     } else {
    //       this.awardCounts[entry.Incident] = 1
    //     }
    //   })
    // }
  },
  mounted () {
    setTimeout(() => {
      this.$store.commit('loading', false)
      this.$store.commit('toggle_dialog', true)
    }, 500)
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/guidanceV2')
        .then(resp => {
          vm.guidanceEntries = resp.data.guidanceEntries
          vm.dbasename = vm.$store.state.Dbasename
          if (vm.dbasename === 'BalmoralSDA') {
            vm.callIncident()
          }
          vm.$store.commit('loading', false)
        })
    })
  }
}
</script>
